import { Flame, ThermometerSun, Sprout, Trash2 } from "lucide-react"

// PAIR bands → presentation. Colors echo the lead-status palette already used
// across the app (slate/blue/violet/amber/green) so the queue feels native.
export const BAND_META = {
  hot:     { label: "Hot",     Icon: Flame,         badge: "bg-red-100 text-red-700 border-red-200",        dot: "bg-red-500",     bar: "bg-red-500" },
  warm:    { label: "Warm",    Icon: ThermometerSun, badge: "bg-amber-100 text-amber-700 border-amber-200",  dot: "bg-amber-500",   bar: "bg-amber-500" },
  nurture: { label: "Nurture", Icon: Sprout,        badge: "bg-blue-100 text-blue-700 border-blue-200",     dot: "bg-blue-500",    bar: "bg-blue-500" },
  junk:    { label: "Junk",    Icon: Trash2,        badge: "bg-slate-100 text-slate-600 border-slate-200",  dot: "bg-slate-400",   bar: "bg-slate-400" },
}

export const VERDICT_LABELS = {
  genuine_interested: "Genuine · interested",
  genuine_not_ready:  "Genuine · not ready",
  not_capable:        "Not capable (budget)",
  not_interested:     "Not interested",
  fake_invalid:       "Fake / invalid",
  unresponsive:       "Unresponsive",
}

// The four PAIR dimensions, in display order, with short descriptions for tooltips.
export const DIMENSIONS = [
  { key: "perception", label: "Perception", short: "P", hint: "Trust in builder credibility & project quality" },
  { key: "ability",    label: "Ability",    short: "A", hint: "Whether pricing fits their budget comfort" },
  { key: "intent",     label: "Intent",     short: "I", hint: "Genuine seriousness about buying" },
  { key: "readiness",  label: "Readiness",  short: "R", hint: "Timeline & readiness to act / visit" },
]

// Score → tailwind text/bar color for a single dimension cell.
export function scoreColor(score) {
  if (score == null) return "text-slate-400"
  if (score >= 70) return "text-emerald-600"
  if (score >= 45) return "text-amber-600"
  return "text-slate-400"
}

export function scoreBar(score) {
  if (score == null) return "bg-slate-200"
  if (score >= 70) return "bg-emerald-500"
  if (score >= 45) return "bg-amber-500"
  return "bg-slate-300"
}
